module.exports = __webpack_public_path__ + "img/26.5.COD.7160e33a.png";